import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeHandlerService } from './module/idp/service/theme-handler.service';
import { IdpHeaderComponent } from './module/shared/component/idp-header/idp-header.component';
import moment from 'moment';
import { IdpFooterComponent } from './module/shared/component/idp-footer/idp-footer.component';

@Component({
  selector: 'app-root',
  imports: [IdpHeaderComponent, IdpFooterComponent, RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private themeHandler = inject(ThemeHandlerService);

  constructor() {
    moment.locale('sv');
  }

  ngOnInit() {
    this.themeHandler.fetchTheme();
  }
}
